import React, { Component } from 'react';
import { Form, Input, Button, Row, Col, Checkbox } from 'antd';

import '../../auth.scss';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';

const layout = {
	labelCol: { span: 24 },
	wrapperCol: { span: 24 },
};

export default class WelcomePresentational extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isRememberMe: false,
			password: null,
			userName: null,
			showCreditNote: false
		};
	}

	formRef = React.createRef();
	_reCaptchaRef = React.createRef();

	checkFieldValid = () => {};

	onFinishFailed = ({ errorFields }) => {};

	componentWillMount() {
		if (JSON.parse(localStorage.getItem('isRememberMe')) === true) {
			this.setState({
				isRememberMe: JSON.parse(localStorage.getItem('isRememberMe')) || false,
				userName: localStorage.getItem('userName') ? atob(localStorage.getItem('userName')) : null,
				password: localStorage.getItem('password') ? atob(localStorage.getItem('password')) : null,
			});
		} else {
			localStorage.removeItem('userName');
			localStorage.removeItem('password');
		}
	}

	onRememberMe = (isRememberMe) => {
		this.setState({
			isRememberMe: isRememberMe,
		});
		localStorage.setItem('isRememberMe', JSON.stringify(isRememberMe));
		if (isRememberMe) {
			localStorage.setItem('userName', btoa(this.state.userName || ''));
			localStorage.setItem('password', btoa(this.state.password || ''));
		} else {
			localStorage.removeItem('userName');
			localStorage.removeItem('password');
		}
	};

	setCreditNote = () => {
		this.setState({ showCreditNote: !this.state.showCreditNote })
	}

	render() {
		const { loginLoading, goToSignUp, goToForgot, onFinish } = this.props;
		const { showCreditNote } = this.state;
		return (
			<Row>
				<Col
					onClick={this.setCreditNote}
					md={{ span: 13 }}
					lg={{ span: 16 }}
					sm={{ span: 24 }}
					className="welcome_img cursor-pointer"
				>
					<ImageComponent src={images.welcome} />
				</Col>

				<Col md={{ span: 11 }} lg={{ span: 8 }} sm={{ span: 24 }} xs={24} className="right_area">
					<Col className="logo_area ">
						<ImageComponent src={images.logo_sm} />
					</Col>
					<Col className="logo_area log_img"></Col>
					<Col className="sign_in">
						Sign <span>In </span>
					</Col>
					<Form
						autoComplete={this.state.isRememberMe ? 'on' : 'off'}
						style={{ marginTop: '30px' }}
						hideRequiredMark={true}
						{...layout}
						layout="vertical"
						name="control-ref"
						ref={this.formRef}
						initialValues={{
							userName: this.state.userName,
							password: this.state.password,
						}}
						onFinishFailed={this.onFinishFailed}
						onFinish={onFinish}>
						<Form.Item
							validateTrigger={['onBlur']}
							className="noreq"
							name="userName"
							label="Username"
							rules={[
								{
									required: true,
									message: 'Invalid Username!',
								},
								// {
								// 	min: 5,
								// 	message: 'Username must be atleast 5 characters',
								// },
								// {
								// 	pattern: new RegExp(/^[_A-z]*((-|\s)*[_A-z])*$/),
								// 	message: 'Username cannot contain special characters & numbers',
								// },
							]}>
							<Input
								id="userName"
								name="userName"
								autoComplete={this.state.isRememberMe ? 'on' : 'off'}
								onInput={(e) => this.setState({ userName: e.target.value })}
								onBlur={() => this.checkFieldValid()}
							/>
						</Form.Item>
						<Form.Item
							style={{ margin: '40px 0px' }}
							className="noreq"
							name="password"
							label="Password"
							validateTrigger={['onBlur']}
							rules={[
								{
									required: true,
									message: 'Please input your password!',
								},
								// {
								// 	min: 8,
								// 	message: 'Password must be a minimum of 8 characters.',
								// },
								// {
								// 	pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*^?&])[A-Za-z\d@$!%^*?&]{8,}$/),
								// 	message: 'Must contain minimum 1 Capitalcase letter, 1 Lowercase letter & 1 Special characters',
								// },
							]}>
							<Input.Password
								id="password"
								name="password"
								onInput={(e) => this.setState({ password: e.target.value })}
								autoComplete={this.state.isRememberMe ? 'on' : 'off'}
							/>
						</Form.Item>

						<Col className="remember_me">
							{' '}
							<Checkbox defaultChecked={this.state.isRememberMe} onChange={(e) => this.onRememberMe(e.target.checked)}>
								Remember Me ?
							</Checkbox>{' '}
						</Col>
						<Col className="forgot-pswd" onClick={goToForgot}>
							Forgot Password ?
						</Col>

						<Form.Item style={{ margin: ' 30px 0px' }}>
							<Button className="k_btn" htmlType="submit" loading={loginLoading}>
								Sign In
							</Button>
							<Col className="first_time">
								First Time Here? <span onClick={goToSignUp}>Click Here to Sign Up</span>
							</Col>
						</Form.Item>
					</Form>
					{showCreditNote && <Row className="credit-notes">
						<div>
							Designed by Bridget Machovec
						</div>
					</Row>}
				</Col>
			</Row>
		);
	}
}
